import { Box, Typography, Paper } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface LevelsCompletionChartProps {
  levelsCompleted: number;
  totalLevels: number;
}

export function LevelsCompletionChart({
  levelsCompleted,
  totalLevels,
}: LevelsCompletionChartProps) {
  const remaining = totalLevels - levelsCompleted;
  const _completionPercentage = Math.round((levelsCompleted / totalLevels) * 100);

  const data = [
    { name: 'Completed', value: levelsCompleted },
    { name: 'Remaining', value: remaining },
  ];

  const COLORS = ['#22c55e', '#374151']; // Green for completed, gray for remaining

  return (
    <Paper
      sx={{
        backgroundColor: '#1f2937',
        color: '#ffffff',
        borderRadius: 2,
        padding: 3,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Typography
          sx={{
            color: '#9ca3af',
            fontSize: '0.875rem',
            marginBottom: 2,
            fontWeight: 400,
          }}
        >
          Levels Completed
        </Typography>

        <Box
          sx={{
            position: 'relative',
            width: '200px',
            height: '200px',
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                startAngle={90}
                endAngle={450}
                dataKey="value"
                stroke="none"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} stroke="none" />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          {/* Center text */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#ffffff',
                fontSize: '1.5rem',
                fontWeight: 600,
                lineHeight: 1,
              }}
            >
              {levelsCompleted}
            </Typography>
            <Typography
              sx={{
                color: '#9ca3af',
                fontSize: '0.875rem',
                fontWeight: 400,
              }}
            >
              of {totalLevels}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
